import { Wallet as WalletIcon, Activity, TrendingUp } from "lucide-react";
import AnimatedNumber from "../AnimatedNumber";

const usd = (n) =>
  (Number.isFinite(n) ? n : 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const Card = ({ label, icon: Icon, accent, children }) => (
  <div className="group relative bg-[#0A0A0A] rounded-xl border border-[#1F1F1F] p-5 sm:p-6 transition-colors hover:border-[#2E2E2E]">
    <div className="flex items-start justify-between">
      <div className="text-[11px] uppercase tracking-[0.12em] text-[#71717A] font-medium">{label}</div>
      {Icon && (
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${accent ? "bg-white/10 text-[#EDEDED]" : "bg-white/5 text-[#71717A]"}`}>
          <Icon size={15} />
        </div>
      )}
    </div>
    {children}
  </div>
);

// Reference-style balance: big grouped amount + USDT unit + "≈ $x" fiat line
const BalanceValue = ({ value, testid }) => (
  <>
    <div className="flex items-baseline gap-2 flex-wrap mt-3">
      <AnimatedNumber value={value} className="font-mono text-[26px] sm:text-[30px] leading-none font-semibold text-white tracking-tight" data-testid={testid} />
      <span className="inline-flex items-center gap-0.5 text-[#71717A] text-sm font-medium">
        USDT
      </span>
    </div>
    <div className="text-[#71717A] text-xs font-mono mt-1.5">≈ ${usd(value)}</div>
  </>
);

const BalanceCards = ({ user, stats }) => {
  const income = stats?.total_income ?? 0;
  const incomePositive = income >= 0;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-8">
      <Card label="Доступный баланс" icon={WalletIcon} accent>
        <BalanceValue value={user?.balance || 0} testid="balance-available" />
      </Card>
      <Card label="В работе" icon={Activity}>
        <BalanceValue value={user?.trading_balance || 0} testid="balance-trading" />
      </Card>
      <Card label="Доход по открытым" icon={TrendingUp}>
        <div className="flex items-baseline gap-2 flex-wrap mt-3">
          <AnimatedNumber
            value={income}
            prefix="$"
            showSign
            className={`font-mono text-[26px] sm:text-[30px] leading-none font-semibold tracking-tight ${incomePositive ? "text-[#EDEDED]" : "text-[#F87171]"}`}
            data-testid="balance-open-income"
          />
          <span className="text-[#71717A] text-sm font-medium">USDT</span>
        </div>
        <div className="text-[#71717A] text-xs font-mono mt-1.5">по открытым позициям</div>
      </Card>
    </div>
  );
};

export default BalanceCards;
